import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { resolveUfsHost } from '@/utils/ufs.utils';
import { LANGUAGE, LanguageHeader } from '@/constants/system';

// baseUrl comes from the runtime tenant config (ufsApiHost), resolved per-request
// from the store — not a build-time env. SSO requests only fire after render, by
// which point the config bag is loaded (ADR-07 step ①).
const ssoBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = (args, api, extraOptions) =>
  fetchBaseQuery({
    baseUrl: resolveUfsHost(),
    prepareHeaders: headers => {
      const selectedLang = localStorage.getItem(LANGUAGE);
      const headerLang = selectedLang
        ? LanguageHeader[selectedLang as keyof typeof LanguageHeader]
        : LanguageHeader.en;

      // `Cloud-Levvel-Tenant` removed here too (batch 004, ADR-6). The skeptic
      // objected that ufs is per-ENVIRONMENT and not per-tenant, so the
      // host==tenant argument would not cover it — but the premise that ufs source
      // was unavailable was wrong (it is rpms/ufs), and a direct read settled it:
      // `Cloud-Levvel-Tenant` has ZERO hits in the entire ufs module, and its
      // tenant comes from the SSO request's `identifier` param and from the SAML
      // RelayState. The header was pure noise on this host.
      headers.set('Cloud-Levvel-Source', 'web');
      headers.set('accept-language', headerLang);
      return headers;
    },
  })(args, api, extraOptions);

export default ssoBaseQuery;
